// extracted by mini-css-extract-plugin
module.exports = {"flex":"OPWlg7OKR6LlF4vpW10Am"};